import type { ClockingSlot } from '../types'

export const getCreatedClockingSlotId = (
  response: unknown
): ClockingSlot['id'] | null => {
  if (!response || typeof response !== 'object') return null

  const { ids } = response as { ids?: unknown }
  if (!Array.isArray(ids) || ids[0] == null) return null

  return ids[0] as ClockingSlot['id']
}
